class EmailSignupBlock extends HTMLElement {
  constructor() {
    super();
    /** @type {number} */
    this.lastButtonWidth = 0;
    /** @type {ResizeObserver | undefined} */
    this.observer = undefined;
  }

  connectedCallback() {
    this.button = this.querySelector('.email-signup__button--integrated');
    this.input = this.querySelector('.email-signup__input');
    this.inputGroup = this.querySelector('.email-signup__input-group');

    const isTextButton = this.button && this.button.classList.contains('email-signup__button--text');

    if (this.button && this.input && this.inputGroup && isTextButton) {
      this.observer = new ResizeObserver((entries) => {
        const inlineSize = entries[entries.length - 1]?.borderBoxSize?.[0]?.inlineSize;
        if (inlineSize !== undefined) {
          this.#applyPadding(inlineSize);
        }
      });
      // Defer observe() to avoid a sync layout read during connectedCallback.
      // ResizeObserver fires its initial callback (with borderBoxSize) in the next task,
      // and again whenever the button resizes — covering font-load size changes too.
      setTimeout(() => { if (this.button) this.observer?.observe(this.button); }, 0);
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  /** @param {number} width */
  #applyPadding(width) {
    if (!this.inputGroup) return;
    if (width !== this.lastButtonWidth) {
      this.lastButtonWidth = width;
      /** @type {HTMLElement} */ (this.inputGroup).style.setProperty('--button-actual-width', `${width}px`);
    }
  }
}

if (!customElements.get('email-signup-block')) {
  customElements.define('email-signup-block', EmailSignupBlock);
}
